import { render } from "./ViewTransactionStatusesModal.vue?vue&type=template&id=504cd810"
import script from "./ViewTransactionStatusesModal.vue?vue&type=script&lang=js"
export * from "./ViewTransactionStatusesModal.vue?vue&type=script&lang=js"

import "./ViewTransactionStatusesModal.vue?vue&type=style&index=0&id=504cd810&lang=css"
script.render = render

export default script